import { ref, uploadBytes, getBlob, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "./firebase";

export function uploadFile(image, route) {
    const storageRef = ref(storage, route)

    uploadBytes(storageRef, image).then(() => {
    }).catch(e => { })
}

export async function uploadFileURL(image, route) {
    const storageRef = ref(storage, route)
    const file = await fetch(image).then(r => r.blob())

    uploadBytes(storageRef, file).then(() => {
    }).catch(e => { })
}

export async function removeFile(route) {
    // Create a reference to the file to delete
    const removeRef = ref(storage, route);

    // Delete the file
    deleteObject(removeRef).then(() => {
    }).catch(e => { });
}

export async function getImageURL(route) {
    const storageRef = ref(storage, route)
    const downloadURL = await getDownloadURL(storageRef)

    //Elimino el access token
    return downloadURL.slice(0, -43)
}

export async function getImage(route) {
    const storageRef = ref(storage, route)

    //return await getBlob(storageRef)
    return await getBlob(storageRef).then(value => { return value }).catch(e => { return null })
}

export function deleteImage() {

}